import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { ChromePicker } from 'react-color';

const ColorPickerDialog = ({ isOpen, onClose, onColorSelected }) => {
  const [currentColor, setCurrentColor] = useState('#ffffff');

  const handleColorChange = (color) => {
    setCurrentColor(color.hex);
  };

  const handleColorSelection = () => {
    onColorSelected(currentColor);
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Choose a color</DialogTitle>
      <DialogContent>
        <ChromePicker color={currentColor} onChange={handleColorChange} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleColorSelection}>Select</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColorPickerDialog;
